module.exports = __webpack_public_path__ + "img/india.a7e18f09.svg";